import React, { useState, useEffect, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty, isColorBright, isDesktop } from '../../lib/ep.js';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink.js';
import BuilderCanvas from '../builder/BuilderCanvas';
import BuilderMain from '../builder/BuilderMain.js';
import BuilderSidebar from '../builder/BuilderSidebar';
import ButtonCollection from '../builder/ButtonCollection.js';
import ColorPicker from '../builder/ColorPicker.js';
import DisabledArea from '../builder/DisabledArea.js';
import DynamicFields from '../builder/DynamicFields.js';
import { AutoPostImageUploader } from '../builder/ImageUploader.js';
import Input from '../builder/Input';
import Message from '../builder/Message.js';
import { NavigationTabsBuilder } from '../builder/NavigationTabs';
import Model from '../builder/Model';
import Range from '../builder/Range.js';
import Select from '../builder/Select.js';
import Spinner from '../builder/Spinner';

import BuilderSubSectionTitle from './BuilderSubSectionTitle.js';

import { GameContainerWrapper } from '../front/GameContainer.js';
import Layout from '../front/Layout';
import SmashItClient from '../front/SmashItClient.js';

import SmashItTemplateLayer from '../games/SmashItTemplateLayer.js';

import Checkbox from '../builder/Checkbox.js';
import SoundSelect from '../builder/SoundSelect.js';
import GameInstructionsBuilder from './GameInstructionsBuilder.js';
import GameScoreBuilder from './GameScoreBuilder.js';
import GameSoundtrackFields from '../builder/GameSoundtrackFields.js';

const SmashField = ({ model, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ uploading, setUploading ] = useState(false);

	const auto_img_hooks = (hook) => {
		switch(hook.type) {
			case 'AUTO_IMAGE_START':
				setUploading(true);
				break;

			case 'AUTO_IMAGE_END':
				setUploading(false);
				break;
		}
	}

	return (
		<DisabledArea disabled={uploading}>
			<Model model={model} change={change} errors={props.errors != undefined && props?.errors[model.id]}>
				<AutoPostImageUploader
					auto_url={`/promotions/auto_img/${props.promotion_id}`}
					auto_type='stages'
					changeMulti={props.changeMulti}
					hooks={auto_img_hooks}
					image={model.full_image}
					name="image"
					small_input={true}
					_size={{width:300, height:300}}
					_class={{ size:50 }}
				>Image</AutoPostImageUploader>

				<Input
					name="name"
					_class={{size:70}}
					autotranslate={false}
				>{i18n("***Name").replace("***","")}</Input>
			</Model>
		</DisabledArea>
	)
};

const GameSettings = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [ errors, setErrors ] = useState({});
	const [ loading, setLoading ] = useState(false);
	const [ uploading, setUploading ] = useState(false);

	const uploadingImages = useRef(0);

	useEffect(() => {
		if(stage.smash_images == undefined)validate([]);
	}, []);

	/*const uploadBulkImages = (k,v,name) => {
		if(name==undefined)return;
		const total_images = stage.smash_images != undefined ? (stage.smash_images).length : 0;
		uploadingImages.current++;
		setUploading(true);
		$.post(`/promotions/auto_img/${stage.promotion_id}`, { image:v, type:'stages', name:name }, (response) => {
			let new_image = {};
			new_image.id = uuidv4();
			new_image.title = "Image";
			new_image.type = 'crush_field';
			new_image.image = response.name;
			new_image.name = name!=undefined ? name.replace(/\\/g,'/').replace(/.*\//, '').replace(/\.[^/.]+$/, "").replace(/_/g, ' ').replace(/-/g, ' ') : 'Image';
			new_image.points = 10;
			new_image.full_image = imgPath(EP.BUCKET,stage.promotion_id,'stages') + new_image.image;

			let v = stage.smash_images != undefined ? [...stage.smash_images,new_image] : [new_image];
			validate(v);//Fa el change

			uploadingImages.current--;
			if(uploadingImages.current<=0)setUploading(false);
		}, 'JSON');
	};*/

	const validate = (v) => {
		return true;

		v = (v == undefined) ? stage.smash_images : v;
		let errors = {};
		let total_images = v.length; //stage.smash_images != undefined ? Object.keys(stage.smash_images).length : 0;
		let errors_images = false;

		if(total_images < num_elements) {
			const remaining_images = num_elements - total_images;

			if(remaining_images > 1) {
				errors['smash_images'] = props.intl.formatMessage({ id:"Still missing {remain} items" }, { remain:remaining_images });
			} else {
				errors['smash_images'] = i18n("Still missing 1 item");
			}
		}

		if(errors_images) errors['images'] = i18n("Some items are missing information");

		setErrors(errors);
		

		setLoading(true);

		setTimeout(() => {
			setLoading(false);
		}, 0);
	};

	const changeSidebar = (k, v) => {
		change(k, v);
		//validate();
	};

	const section_title = `${i18n("Items", 'ucfirst')} (${(stage?.smash_images ?? []).length})`;

	const dynamic_fields = [{
		type:'ok',
		label:"OK",
		title:(f) => (f?.name ?? "OK"),
		max:3,
	}, {
		type:'ko',
		label:"KO",
		title:(f) => (f?.name ?? "KO"),
		max:3,
	}, {
		type:'superok',
		label:"Super OK",
		title:(f) => (f?.name ?? "Super OK"),
		max:1,
	}, {
		type:'superko',
		label:"Super KO",
		title:(f) => (f?.name ?? "Super KO"),
		max:1,
	}];

	const option_level = [
		{ k:'slow', v:i18n("Slow") },
		{ k:'normal', v:i18n("Normal") },
		{ k:'fast', v:i18n("Fast") },
	];

	const grid_options = [
		//{ k:1, v:i18n("1x1") },
		{ k:2, v:i18n("2x2") },
		{ k:3, v:i18n("3x3") },
		{ k:4, v:i18n("4x4") },
		{ k:5, v:i18n("5x5") },
	];

	let smash_images_for_play = stage?.smash_images ?? [];
	smash_images_for_play.map((item, i) => {
		smash_images_for_play[i] = { ...item, subtitle:item.type.toUpperCase() };
	});

	return (
		<>
			<BuilderSidebar onSave={props.saveStage} errors={errors}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<article>
					<Model model={stage} change={changeSidebar}>
						<Select
							name="smash_grid"
							values={grid_options}
							_class={{size:40, first:true}}
						>Grid</Select>

						<Select
							name="smash_level"
							values={option_level}
							_class={{size:40 }}
						>Speed</Select>

						<Range
							min={30}
							max={90}
							step={5}
							label_props={{
								addition:"In seconds",
							}}
							_class={{ size:50 }}
							name="game_time"
							value={(stage.game_time != undefined) ? Math.max(stage.game_time, 30) : 180}
						>Time of game</Range>
					</Model>
				</article>

				<article class="gui_not_in_top gui_not_in_bottom">
					<DynamicFields
						section_title={section_title}
						onChange={(v) => changeSidebar('smash_images', v)}
						field_types={dynamic_fields}
						add_button_props={{
							icon:'knk-add-item mainButton',
						}}
						sortable={false}
						fields={smash_images_for_play}
					>
						<SmashField
							promotion_id={stage.promotion_id}
							errors={errors}
							intl={props.intl}
						/>
					</DynamicFields>
				</article>

				<article class="gui_not_in_top_huge">
					<BuilderSubSectionTitle
						title={i18n("Cells")}
						subtitle={`${i18n("A cell is the square formed by a base image and a background. Elements will emerge from the base and be displayed on top of the background.")} <strong>${i18n("The base image is mandatory.")}</strong>`}
						autotranslate={false}
						icon='knk-layers'
					/>

					<Model model={stage} change={changeSidebar}>
						<AutoPostImageUploader
							auto_url={`/promotions/auto_img/${props.promotion.id}`}
							auto_type='stages'
							name="smash_item_cover_image"
							image={stage.full_smash_item_cover_image}
							display_custom_dragging_instructions="Upload the image"
							small_input={true}
							_size={{ height:100, width:300 }}
							enable_actions={false}
						>Base image</AutoPostImageUploader>

						<ColorPicker
							_class={{ size:50 }}
							_hide_code={true}
							name="smash_item_bg_color"
							color={stage?.smash_item_bg_color ?? '#FFFFFF'}
						>Cell background color</ColorPicker>

						<AutoPostImageUploader
							auto_url={`/promotions/auto_img/${props.promotion.id}`}
							auto_type='stages'
							name="smash_item_bg_image"
							image={stage.full_smash_item_bg_image}
							display_custom_dragging_instructions="Upload the image"
							small_input={true}
							_size={{ width:300, height:300 }}
						>Cell background</AutoPostImageUploader>
					</Model>
				</article>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout promo={props.promotion} is_builder={true} page="quiz" menus={props.promoModel.Custom__Menus} layout_extra_classes="is_new_game">
					<div style={{width:'100%'}}>
						{(loading) ? (
							<div class="gui_not_in_top gui_flex_center" style={{width:'100%',height:'100%'}}>
								<Spinner>Generating a new board</Spinner>
							</div>
						) : (
							(Object.keys(errors).length == 0) ? (
								<SmashItClient
									key={stage?.smash_grid ?? 4}
									stage={{ Stage:stage }}
									is_builder={true}
									is_playable={true}
									section="settings"
								/>
							) : (
								<GameContainerWrapper>
									<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
										{Object.values(errors).map((error, i) => {
											let is_object = (typeof error === 'object') ? true : false;
											if(is_object) return null;
											return (
												<p key={`error${i}`}>{error}</p>
											)
										})}
									</div>
								</GameContainerWrapper>
							)
						)}
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const GameDesign = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ errors, setErrors ] = useState({});
	const [ loading, setLoading ] = useState(false);
	const [ display_template_layer, setDisplayTemplateLayer ] = useState(false);

	useEffect(() => {
		if(stage.smash_images == undefined) validate([]);
	}, []);

	const validate = (v) => {
		return
		v = (v == undefined) ? stage.smash_images : v;
		let errors = {};
		let total_images = v.length; //stage.smash_images != undefined ? Object.keys(stage.smash_images).length : 0;
		let errors_images = false;

		if(total_images < num_elements) {
			const remaining_images = num_elements - total_images;

			if(remaining_images > 1) {
				errors['smash_images'] = props.intl.formatMessage({ id:"Still missing {remain} items" }, { remain:remaining_images });
			} else {
				errors['smash_images'] = i18n("Still missing 1 item");
			}
		}

		if(errors_images) errors['images'] = i18n("Some items are missing information");

		setErrors(errors);
		change('smash_images', v);

		setLoading(true);

		setTimeout(() => {
			setLoading(false);
		}, 0);
	};

	const changeSidebar = (k,v) => {
		change(k,v);
		validate();
	};

	const animations = [
		{ k:'shake', v:i18n("Shake") },
		{ k:'slide_up', v:i18n("Slide up") },
		{ k:'fall_aside', v:i18n("Fall aside") },
		{ k:'fade_out', v:i18n("Fade out") },
		{ k:'custom', v:i18n("Image replace") },
	];

	const sounds_ok = [
		{ k:'none', v:i18n("***None") },
		{ k:'success', v:i18n("Success") },
		{ k:'slide', v:i18n("Slide") },
		{ k:'cross', v:i18n("Cross") },
		{ k:'flag', v:i18n("Flag") },
		{ k:'hint', v:i18n("Hint") },
		{ k:'unplug', v:i18n("Unplug") },
	];

	const sounds_ko = [
		{ k:'none', v:i18n("***None") },
		{ k:'error_backflip', v:i18n("Backflip") },
		{ k:'error_buzzer', v:i18n("Buzzer") },
		{ k:'funny_laugh', v:i18n("Funny laugh") },
		{ k:'unplug', v:i18n("Unplug") },
	];

	const ok_color_optimal = (isNotEmpty(stage, 'smash_ok_color') && !isColorBright(stage.smash_ok_color)) ? false : true;
	const ko_color_optimal = (isNotEmpty(stage, 'smash_ko_color') && !isColorBright(stage.smash_ko_color)) ? false : true;
	const miss_color_optimal = (isNotEmpty(stage, 'smash_miss_color') && !isColorBright(stage.smash_miss_color)) ? false : true;
	let optimal_message_title = false;
	if(!ok_color_optimal && !ko_color_optimal && !miss_color_optimal) {
		optimal_message_title = "Are all colors too dark?";
	} else if(!ok_color_optimal) {
		optimal_message_title = "Is OK color too dark?";
	} else if(!ko_color_optimal) {
		optimal_message_title = "Is KO color too dark?";
	} else if(!miss_color_optimal) {
		optimal_message_title = "Is MISS color too dark?";
	}

	const max_padding = 100;

	const used_types = ['ok'];
	if(stage.smash_images.filter((i) => (i.type == 'ko')).length > 0) used_types.push('ko');
	if(stage.smash_images.filter((i) => (i.type == 'superok')).length > 0) used_types.push('superok');
	if(stage.smash_images.filter((i) => (i.type == 'superko')).length > 0) used_types.push('superko');

	return (
		<>
			<BuilderSidebar onSave={props.saveStage} errors={errors}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<Model model={stage} change={changeSidebar}>
					<Checkbox
						name="display_outter_border"
						value={stage?.display_outter_border ?? true}
						_class={{ first:true }}
					>Display outer border</Checkbox>

					<Checkbox
						name='silence'
					>Disable sounds</Checkbox>
				</Model>

				<GameSoundtrackFields
					stage={stage}
					change={change}
				/>

				<article class='gui_not_in_top_huge'>
					<BuilderSubSectionTitle
						title="Grid design"
						icon='knk-quiz'
					/>

					<Model model={stage} change={changeSidebar}>
						<Range
							min={0}
							max={20}
							step={1}
							name="smash_layout.gap"
							_class={{ size:50 }}
							value={stage?.smash_layout?.gap ?? 10}
						>Gap between cells</Range>

						<Range
							min={0}
							max={max_padding}
							step={1}
							name="smash_layout.padding.top"
							_class={{ size:50 }}
							value={stage?.smash_layout?.padding?.top ?? 10}
						>Padding top</Range>

						<Range
							min={0}
							max={max_padding}
							step={1}
							name="smash_layout.padding.right"
							_class={{ size:50 }}
							value={stage?.smash_layout?.padding?.right ?? 10}
						>Padding right</Range>

						<Range
							min={0}
							max={max_padding}
							step={1}
							name="smash_layout.padding.bottom"
							_class={{ size:50 }}
							value={stage?.smash_layout?.padding?.bottom ?? 10}
						>Padding bottom</Range>

						<Range
							min={0}
							max={max_padding}
							step={1}
							name="smash_layout.padding.left"
							_class={{ size:50 }}
							value={stage?.smash_layout?.padding?.left ?? 10}
						>Padding left</Range>

						<AutoPostImageUploader
							auto_url={`/promotions/auto_img/${stage.promotion_id}`}
							auto_type='stages'
							image={stage.full_smash_cover_image}
							name="smash_cover_image"
							small_input={true}
							_size={{ width:800, height:800 }}
							label_props={{
								_extra_component:(isDesktop()) ? <ActionLink onClick={() => setDisplayTemplateLayer(true)}>Info</ActionLink> : null,
							}}
						>Grid foreground image</AutoPostImageUploader>

						<AutoPostImageUploader
							auto_url={`/promotions/auto_img/${stage.promotion_id}`}
							auto_type='stages'
							image={stage.full_smash_bg_image}
							name="smash_bg_image"
							small_input={true}
							_size={{ width:800, height:800 }}
							label_props={{
								_extra_component:(isDesktop()) ? <ActionLink onClick={() => setDisplayTemplateLayer(true)}>Info</ActionLink> : null,
							}}
						>Grid background image</AutoPostImageUploader>

						{(stage?.smash_bg_image ?? true) && (
							<ColorPicker
								_class={{ size:50 }}
								_hide_code={true}
								name="smash_bg_color"
								color={stage?.smash_bg_color ?? '#CCCCCC'}
							>Background color</ColorPicker>
						)}
					</Model>
				</article>

				<article class="gui_not_in_top_huge">
					<BuilderSubSectionTitle
						title="Colors on tap"
						icon='knk-artist-mode'
					/>

					<Model model={stage} change={changeSidebar}>
						<ColorPicker
							_class={{ size:50 }}
							_hide_code={true}
							name="smash_ok_color"
							color={stage?.smash_ok_color ?? 'rgba(120, 195, 0, 1)'}
							autotranslate={false}
						>{i18n("Cell color")}: {i18n("OK")}</ColorPicker>

						<ColorPicker
							_class={{ size:50 }}
							_hide_code={true}
							name="smash_ko_color"
							color={stage?.smash_ko_color ?? 'rgba(210, 210, 210, 1)'}
						>{i18n("Cell color")}: {i18n("KO")}</ColorPicker>

						<ColorPicker
							_class={{ size:50 }}
							_hide_code={true}
							name="smash_miss_color"
							color={stage?.smash_miss_color ?? 'rgba(255, 255, 255, 1)'}
						>{i18n("Cell color")}: {i18n("MISS")}</ColorPicker>
					</Model>

					{(!ok_color_optimal || !ko_color_optimal || !miss_color_optimal) && (
						<Message
							title={optimal_message_title}
						/>
					)}
				</article>

				{used_types.map((type) => {
					return (
						<article class="gui_not_in_top_huge">
							<BuilderSubSectionTitle
								title={props.intl.formatMessage({ id:"Effects on tap ({type})" }, { type:i18n(type, 'uppercase') })}
								autotranslate={false}
								icon='knk-developers'
							/>

							<Model key={`info_${type}`} model={stage} change={changeSidebar}>
								{((stage?.silence ?? false) === false) && (
									<SoundSelect
										name={`smash_effects.${type}.sound_fx`}
										values={(type.indexOf('ok') != -1) ? sounds_ok : sounds_ko}
										_class={{ size:50 }}
									>Sound FX</SoundSelect>
								)}

								<Select
									name={`smash_effects.${type}.animation`}
									values={animations}
									_class={{ size:50 }}
								>Animation</Select>

								{(stage.smash_effects != undefined && stage.smash_effects[type] != undefined &&  stage.smash_effects[type].animation == 'custom') && (
									<AutoPostImageUploader
										name={`smash_effects.${type}.replace_image`}
										auto_url={`/promotions/auto_img/${stage.promotion_id}`}
										auto_type='stages'
										image={stage.smash_effects[type].full_replace_image}
										small_input={true}
										_size={{width:300, height:300 }}
										_class={{ size:50 }}
									>Image</AutoPostImageUploader>
								)}
							</Model>
						</article>
					)
				})}
			</BuilderSidebar>

			<BuilderCanvas
				fit_to_window="content"
				off_content={<Message
					title="Try the animations and sound FX by clicking on each cell"
					icon={false}
					title_styles={{ justifyContent:'center' }}
					_class={{ other:'in_top in_bottom' }}
				/>}
			>
				<Layout promo={props.promotion} is_builder={true} page="quiz" menus={props.promoModel.Custom__Menus} layout_extra_classes="is_new_game">
					<div style={{width:'100%'}}>
						{(loading) ? (
							<div class="gui_not_in_top gui_flex_center" style={{width:'100%',height:'100%'}}>
								<Spinner>Generating a new board</Spinner>
							</div>
						) : (
							(Object.keys(errors).length == 0) ? (
								<SmashItClient
									stage={{ Stage:stage }}
									is_builder={true}
									is_playable={false}
									section="settings"
									demo_animations={true}
								/>
							) : (
								<GameContainerWrapper>
									<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
										{Object.values(errors).map((error, i) => {
											let is_object = (typeof error === 'object') ? true : false;
											if(is_object) return null;
											return (
												<p key={`error${i}`}>{error}</p>
											)
										})}
									</div>
								</GameContainerWrapper>
							)
						)}
					</div>
				</Layout>

				{(display_template_layer) && (
					<SmashItTemplateLayer
						close={() => setDisplayTemplateLayer(false)}
						stage={stage}
					/>
				)}
			</BuilderCanvas>
		</>
	)
};

const GameTest = ({ stage, change, ...props }) => {
	const restart = () =>{
		let new_reset =( stage.reset != undefined) ? stage.reset + 1 : 0;
		change('reset', new_reset);
	};

	return (
		<>
			<BuilderSidebar without_ctas={true}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<ButtonCollection>
					<ActionButton
						icon='knk-reload'
						onClick={() => restart()}
					>Restart game</ActionButton>
				</ButtonCollection>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout promo={props.promotion} is_builder={true} page="quiz" menus={props.promoModel.Custom__Menus} layout_extra_classes="is_new_game">
					<div style={{width:'100%'}}>
						<SmashItClient
							stage={{ Stage:stage }}
							is_builder={true}
							is_test={true}
						/>
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
}

const SmashItBuilder = ({ base_route, stage, ...props }) => {
	const basename = `/stages/${stage.id}/taptap`;
	const nav_sections = [
		{ label:"Go back", link:`/stages/${stage.id}/options`, icon:'knk-go-prev' },
		{ label:"Gameplay settings", link:`${basename}/settings`, icon:'knk-settings' },
		{ label:"Design", link:`${basename}/design`, icon:'knk-artist-mode' },
		{ label:"Instructions", link:`${basename}/instructions`, icon:'knk-help' },
		{ label:"Score screen", link:`${basename}/gamescore`, icon:'knk-like' },
		{ label:"Test the game", link:`${basename}/test`, icon:'knk-ok' },
	];

	const common_props = {
		stage,
		is_multistage:props.is_multistage,
		isCorporate:props.isCorporate,
		change:props.change,
		changeMulti:props.changeMulti,
		intl:props.intl,
		promotion:props.promotion,
		promoModel:props.promoModel,
		saveStage:props.saveStage,
		stage_indicator:props.stage_indicator,
		nav_sections:nav_sections,
	};

	return (
		<BuilderMain pm={props.promoModel}>
			<Router basename={basename} hashType="noslash">
				<Switch>
					<Route exact={true} path="/settings">
						<GameSettings
							{...common_props}
							nav_active={`/settings`}
						/>
					</Route>

					<Route exact={true} path="/design">
						<GameDesign
							{...common_props}
							nav_active={`/design`}
						/>
					</Route>

					<Route exact={true} path="/instructions">
						<GameInstructionsBuilder
							{...common_props}
							nav_active={`/instructions`}
						>
							<SmashItClient
								stage={{ Stage:stage }}
								promotion={props.promotion}
								is_builder={true}
								section="instructions"
							/>
						</GameInstructionsBuilder>
					</Route>

					<Route exact={true} path="/gamescore">
						<GameScoreBuilder
							{...common_props}
							nav_active={`/gamescore`}
							exclude_cases={['out_of_time', 'out_of_moves']}
							has_threshold={true}
						>
							<SmashItClient
								stage={{ Stage:stage }}
								promotion={props.promotion}
								is_builder={true}
								section="score"
							/>
						</GameScoreBuilder>
					</Route>

					<Route exact={true} path="/test">
						<GameTest
							{...common_props}
							nav_active={`/test`}
						/>
					</Route>
				</Switch>
			</Router>
		</BuilderMain>
	)
}
export default injectIntl(SmashItBuilder);